export let januaryAbbreviatedLowercase = "aZKBxc";
export default {januaryAbbreviatedLowercase};